export const APP_VERSION = '8.30.0';
export const APP_REVISION = '21.212';
export const APP_COPYRIGHT_HOLDER = 'Cromwell Artiaga, Ed.D.';
export const SDI_TEACHER_NAME = 'Dr. Cromwell Artiaga';

export const getCopyrightYear = () => new Date().getFullYear();
export const getVersionLabel = () => `AssessNow v${APP_VERSION} • Revision ${APP_REVISION}`;
export const getCopyrightLabel = () => `Copyright © ${getCopyrightYear()}  ${APP_COPYRIGHT_HOLDER}`;
export const getApplicationLegalLine = () => `${getVersionLabel()}  •  ${getCopyrightLabel()}`;
